import { CREATE_QUIZ_GAME, CREATE_QUIZ_GAME_SUCCESS, CREATE_QUIZ_GAME_ERROR, CREATE_QUIZ_GAME_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateQuizGame = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_QUIZ_GAME:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_QUIZ_GAME_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_QUIZ_GAME_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_QUIZ_GAME_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateQuizGame;
